import { hardNavigation } from "../../../utils/hard-navigation.util";
import { Component, ElementRef, Input, OnDestroy, OnInit, QueryList, Renderer2, ViewChildren } from "@angular/core";
import { FormControl } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { Subject } from "rxjs";
import { concatMap, first, takeUntil, timeout } from "rxjs/operators";
import { getPlanId } from "src/app/core/core-services/constants/plans.constants";
import { DataService } from "src/app/core/core-services/services/dataservices/data.service";
import { ScriptService } from "src/app/core/core-services/services/script.service";
import { StripeService } from "src/app/core/core-services/services/stripe.service";
import { PlanStatus, SubscriptionPlanType } from "src/app/core/models/stripe.models";

import { AuthService } from "src/app/core/core-services/services/auth.service";
import { NotificationService } from "src/app/core/core-services/services/notification.service";
import { NotifyService } from "src/app/core/menu/not.service";
import { trackService } from "src/app/core/core-services/services/track.service";
import { NavigationService } from "src/app/core/core-services/services/navigation.service";
import { CONTACT_SALES_TRACKING_EVENT, CONTACT_SALES_URL } from "src/app/utils/contact-sales.utils";
import { formatPrice } from "src/app/utils/price-format.utils";
import {
  CTA_SALES_PRO_MONTHLY_ID,
  CTA_SALES_PRO_MONTHLY_URL,
  CTA_SALES_PRO_YEARLY_ID,
  CTA_SALES_PRO_YEARLY_URL,
  PLANS_LOAD_TIMEOUT_MS,
} from "./plan-details.config";
import { SharedDataService } from "src/app/core/core-services/services/shared-data.service";
import { PendingCouponService } from "src/app/core/core-services/services/pending-coupon.service";
import { selectPlanData } from "src/app/core/store/plan/plan.selectors";
import { isTruthyFlag } from "src/app/utils/storage-flag.utils";
import { applyDiscount, couponDiscountAmount, CouponAmounts } from "src/app/utils/coupon-price.utils";
import { AnalyticsService } from "src/app/analytics.service";
import {
  InvalidPlansShapeError,
  PlansLoadState,
  classifyPlansLoadError,
  focusPlansLoadResult,
  isPlanPriced,
  isValidPlansResponse,
} from "src/app/utils/plans-load-error.utils";

const stripeStyles = {
  base: {
    backgroundColor: "#F5F5F5",
    borderColor: "#EEEEEE",
  },
};

declare let hbspt: any;
@Component({
    selector: "app-plans-details",
    templateUrl: "./plans-details.component.html",
    styleUrls: ["./plans-details.component.scss"],
    standalone: false
})
export class PlansDetailsComponent implements OnInit, OnDestroy {
  @Input("onboarding")
  onboarding: boolean;

  @ViewChildren("buttons") buttons: QueryList<ElementRef>;

  private stripeId = "";
  public client_secret = "";
  public planType: SubscriptionPlanType;
  public subType = SubscriptionPlanType;
  private _destroy$ = new Subject<void>();
  checked = false;
  isSalesProPlan = false;
  // Form Controls
  // TODO: Need to add other billing details to form and send with request
  PaymentName = new FormControl("");
  faqs = [
    {
      title: 0,
      id: "01",
      qa: "What are my payment options?",
      ans: "You can purchase FlyMSG with any major credit card. It’s totally secure, and we use Stripe for all of our payment processing.",
    },
    {
      title: 1,
      id: "02",
      qa: "What is the difference between Freemium and Starter?",
      ans: "The main difference between our Freemium and Starter plans is that Freemium is free and only offers the basic features you need to get started with FlyMSG while the Starter plan allows for the use of more FlyPlates, the creation of more FlyCuts as well as access to all styling options. ",
    },
    {
      title: 2,
      id: "03",
      qa: "What is the difference between Starter and Growth?",
      ans: "With our Growth plan, you’ll be able to create an unlimited number of FlyCuts, FlyPlates, categories, and subcategories and unlimited access to characters and styling options. Not only that, but you’ll also be able to access our spell check features in any language you want. If you’re looking for increased flexibility and variance within your communications, our Growth plan is perfect for you. It is the most common plan used by our users.",
    },
    {
      title: 3,
      id: "04",
      qa: "Can I cancel my subscription at any time?",
      ans: "Before you cancel, consider pausing your subscription for a month. Perhaps that will help your budget. You can do this under the Subscription section within settings. We’d hate to see you go, but if you don’t want to Type Less and Do More, then all you need to do is cancel the renewal within FlyMSG under the Subscription tab in settings.",
    },
    {
      title: 4,
      id: "05",
      qa: "If I have an Annual Subscription, will it renew automatically?",
      ans: "Yes, you will be automatically charged each year on the anniversary date of your subscription at the full retail price regardless of any discount provided to you at the time of purchase. With your annual subscription, you will have access each year to all existing content, all-new FlyPlates and FlyCuts, technical support, and all-new features launched to support your subscription. The name will appear as “Vengreso - FlyMSG Starter or Growth Plan”. ",
    },
    {
      title: 5,
      id: "06",
      qa: "If I have questions before I buy, who do I contact?",
      ans: "if you have any questions about FlyMSG, please do not hesitate to contact us. We want to make sure that you’re confident in your purchase. Schedule a meeting right now by clicking <a href='https://vengreso.com/contact-us'>here</a> . ",
    },
    {
      title: 6,
      id: "07",
      qa: " What is your refund policy?",
      ans: "We truly believe in our proven process and the power of FlyMSG that it’s highly unlikely you’ll ask for a refund. However, you should know there is no refund policy. Once you cancel, you’ll have access to use the application through the end of that billing cycle, and you won’t be charged for the next. Please note that once you cancel, you’ll be downgraded to a free plan, which means most of your FlyCuts formatting will be lost. If you are over the limit of FlyCuts or characters, you will be locked out from using them until you purchase a subscription. ",
    },
    {
      title: 7,
      id: "08",
      qa: "How do I get support after I become a customer?",
      ans: "We offer chat and email support to HeySupport at Vengreso dot com for all our plans and education solutions. On our Starter and Growth plan, a customer service agent will be readily available to answer your questions from 8-5pm CST. On our Freemium plan, your requests get processed and replied to within 2-3 business days. ",
    },
    {
      title: 8,
      id: "09",
      qa: "What happens when I hit my limits in the free plan?",
      ans: "When you hit your limits in our Freemium plan, you will no longer be able to create additional FlyCuts, use new FlyPlates, or possibly utilize the plan’s included features. ",
    },
  ];

  salesProPlanOffers = [
    "UNLIMITED Ondemand Access",
    "15+ Hours of Sales Prospecting Education",
    "50+ Prospecting Scripts",
    "13 Messaging Playbooks",
    "Live Quarterly Sales Training",
    "Monthly All Access Pass",
  ];

  panelOpenState: boolean[] = [];
  planId;
  localPlanId;
  localPlanIdType;
  onTrial: boolean;
  pricing: any = {};
  planIndex = -1;
  usedTrial: boolean;

  // Coupon pricing for the pending code (issue #596, product decision 2:
  // every plan card the pending coupon is valid for shows the coupon price,
  // not only the trialing user's own plan). Keyed by the same plan
  // identifier `planIdentifier()`/`getPricing()` use ("starter",
  // "sales-pro-monthly", "sales-pro-yearly", …). `couponResults` holds the
  // raw `POST v1/subscriptions/coupon` result so the discounted figure is
  // always recomputed against the latest `pricing` (never cached stale —
  // pricing can still be loading when a coupon result arrives).
  pendingCouponCode: string | null = null;
  private couponResults: Record<string, CouponAmounts> = {};
  private couponRequestsIssued = new Set<string>();

  /**
   * The plans-grid state (issue #600 AC-1/AC-2/AC-4): `"loading"` shows the
   * skeleton placeholder, `"ready"` shows the cards, `"error"` shows the
   * in-page "We couldn't load our plans" block with its Retry button instead
   * of the app's generic `/session/error` page. Starts `"loading"` — the
   * constructor kicks off the request immediately (see `loadPlans()` below).
   */
  plansLoadState: PlansLoadState = "loading";

  constructor(
    private readonly dataService: DataService,
    private readonly route: ActivatedRoute,
    private readonly stripeService: StripeService,
    private readonly _router: Router,
    private readonly renderer: Renderer2,
    private readonly scriptService: ScriptService,
    private readonly notification: NotificationService,
    private readonly sharedData: SharedDataService,
    public notifyService: NotifyService,
    private readonly el: ElementRef,
    private readonly authService: AuthService,
    private readonly pendingCoupon: PendingCouponService,
    private readonly store: Store,
    private readonly analyticsService: AnalyticsService,
    private readonly trackService: trackService,
    private readonly navigationService: NavigationService
  ) {
    // loop to add panels
    for (let i = 0; i < 5; i++) {
      this.panelOpenState.push(false);
    }
    this.planId = getPlanId();

    // The user's plan (SharedDataService's "planId"/"planIdType",
    // populated asynchronously by loadUserCurrentSubscriptionApi) can still
    // be in flight when this component mounts — most reliably reproduced
    // right after a sign-in/sign-up replay lands here on
    // `/pricing?coupon=` (issue #592 F-2). refreshLocalPlanState() must
    // never throw on that "not loaded yet" state; the store subscription in
    // ngOnInit re-runs it once the data actually arrives, so the page
    // recovers instead of staying stuck on a starting page that could not be
    // reliably identified.
    this.refreshLocalPlanState();
    this.loadPlans();
  }

  /**
   * Derives `localPlanId`/`localPlanIdType`/`onTrial`/`usedTrial`,
   * `isSalesProPlan` and `planIndex` (which entries of `this.plans` are
   * "current") from whatever SharedDataService currently holds. Safe to
   * call before the plan has loaded — `planKey` degrades to an empty
   * string instead of throwing on `undefined.split(...)`, matching
   * plans-details.component's pre-#592 behavior when nothing was cached
   * yet (issue #592 F-2). Called once in the constructor for the common
   * case where the plan is already known, and again whenever the store's
   * plan data changes (see ngOnInit) so a page that mounted before the
   * plan loaded still ends up correct once it does.
   */
  private refreshLocalPlanState(): void {
    this.localPlanId = this.sharedData.getAttribute("planId");
    this.localPlanIdType = this.sharedData.getAttribute("planIdType");
    // Pre-load fallback only: `on_trial`/`used_trial` come back from the
    // backend as real booleans (StripeService.getCurrentPlan() stores them
    // verbatim), so a strict `=== "true"` string compare was always false —
    // isTruthyFlag() is boolean-safe (issue #596 AC-1). The store-driven
    // selectPlanData subscription in ngOnInit overrides `onTrial` with the
    // authoritative value once plan data has actually loaded; this remains
    // the value used before that first emission (e.g. this constructor call)
    // and in the tests/callers that only ever populate SharedDataService.
    this.onTrial = isTruthyFlag(this.sharedData.getAttribute("onTrial"));
    this.usedTrial = isTruthyFlag(this.sharedData.getAttribute("usedTrial"));

    const planKeySource = this.localPlanIdType ?? this.localPlanId;
    const planKey = typeof planKeySource === "string" ? planKeySource.split("-")[0].toLowerCase() : "";

    this.planIndex = -1;
    this.plans.forEach((it, ix) => {
      const isCurrent = !!planKey && it.key.includes(planKey);
      it.current = isCurrent;
      if (isCurrent) {
        this.planIndex = ix;
      }
    });

    const salesProIds = ["sales-pro-yearly", "sales-pro-monthly", "sales-pro"];
    this.isSalesProPlan = salesProIds.includes(this.localPlanId) || salesProIds.includes(this.localPlanIdType);
  }
  public currentPlan(plan) {
    return plan.current
      ? (this.localPlanIdType ?? this.localPlanId).includes("yearly")
        ? !this.checked && !this.onTrial
        : this.checked && !this.onTrial
      : false;
  }

  /**
   * True for the trialing user's own plan card, in the billing interval
   * matching their trial SKU — the complement of `currentPlan()` once
   * `onTrial` is true (issue #596 AC-2). This card is never disabled and
   * never shows the "Your Current Plan" ribbon/button; it shows the
   * "Your 14-Day Trial" ribbon and a Subscribe action instead (template).
   */
  public isTrialingOwnPlan(plan): boolean {
    return plan.current && this.onTrial
      ? (this.localPlanIdType ?? this.localPlanId).includes("yearly")
        ? !this.checked
        : this.checked
      : false;
  }

  /**
   * The `v1/subscriptions/plans` / `v1/subscriptions/coupon` identifier for
   * `plan` at a given billing interval — the same remap
   * `displayedPrice()` has always applied (monthly Sales Pro's UI key
   * "sales-pro" is not a pricing/coupon identifier; "sales-pro-monthly" is).
   */
  private planIdentifier(plan: any, checked: boolean): string {
    const key = plan.key + (checked ? "" : "-yearly");
    return key === "sales-pro" ? "sales-pro-monthly" : key;
  }

  /**
   * True when `plan`, at the current billing interval, was omitted from
   * `v1/subscriptions/plans` — i.e. `plan_families` marks it
   * `contact_sales_only` (or otherwise unpublished) on the backend (issue
   * #603 AC-1/AC-2/AC-4). Never true for a legitimately free plan:
   * `isPlanPriced()` checks `pricing[identifier] !== undefined`, not
   * truthiness, so `unit_amount: 0` is still "priced". Freemium and any
   * identifier outside `PRICED_PLAN_IDENTIFIERS` are always "priced" here —
   * no template ever prices them, so they can never be contact-sales-only.
   */
  public isContactSalesOnly(plan: any): boolean {
    return !isPlanPriced(this.pricing, this.planIdentifier(plan, this.checked));
  }

  /**
   * Bound to the "Contact sales" CTA on a card whose plan is absent from the
   * response (issue #603 AC-1, contracts table) — the same URL/tracking
   * event the account menu's existing "Contact Sales" item already fires
   * (`header.component.ts.navigateTo`/`trackService`).
   */
  public contactSales(): void {
    this.trackService.btnClickUpdatetrack(CONTACT_SALES_TRACKING_EVENT);
    this.navigationService.navigateToUrl(CONTACT_SALES_URL);
  }

  public elements = this.stripeService.stripe.elements();
  public paymentElement = this.elements.create("card", {
    style: stripeStyles,
  });

  ngOnInit(): void {
    // Capture a `?coupon=` param before the /plans -> /pricing self-redirect
    // below would otherwise drop it (issue #592, AC-5). The captured code is
    // carried forward via PendingCouponService's sessionStorage stash, not
    // the query string, so the redirect losing the query is harmless.
    this.pendingCoupon.captureFromParams(this.route.snapshot.queryParamMap);

    // Compare the path only, not the full URL: with a query string attached
    // (e.g. "/plans?coupon=X", issue #592 AC-5) the exact string never
    // equalled "/plans", so this self-redirect silently never fired and a
    // ?coupon= arriving via the deprecated /plans alias was stranded there.
    const [routerPath] = this._router.url.split("?");
    if (routerPath === "/plans") {
      // Every query param must survive the redirect, not only `coupon` —
      // e.g. a `utm_*`-tagged link to the deprecated /plans alias was
      // otherwise landing on a bare /pricing with its attribution dropped
      // (QA note on issue #592).
      //
      // replaceUrl: true (QA #593 F-6): without it this self-redirect pushed
      // a history entry, so Back from /pricing returned to /plans?…, which
      // immediately redirected forward again — Back could never leave the
      // page. Replacing the /plans entry instead of pushing on top of it
      // means Back goes straight to whatever the visitor was on before
      // /plans (the referrer, e.g. an email or site link).
      this._router.navigate(["/pricing"], {
        queryParams: this.route.snapshot.queryParams,
        replaceUrl: true,
      });
      return;
    }
    this.planType = SubscriptionPlanType[this.route.snapshot.paramMap.get("id")];
    this.stripeHandler();

    // Re-derive the local plan fields whenever the store's plan data
    // changes, including its first emission after this component has
    // already mounted (issue #592 F-2) — Store.select replays the current
    // value on subscribe, so this also covers the common case where the
    // plan had already loaded before this page was reached.
    this.store
      .select(selectPlanData)
      .pipe(takeUntil(this._destroy$))
      .subscribe((planData) => {
        if (planData) {
          this.refreshLocalPlanState();
          // Prefer the store over the SharedDataService fallback
          // refreshLocalPlanState() just applied (issue #596 AC-1, "trial
          // detection is store-driven"): once real plan data has arrived,
          // its plan_status/on_trial fields are the authoritative signal.
          // A mock/partial planData that carries neither field (as several
          // existing specs do) leaves the attribute-derived value in place
          // rather than forcing it to false.
          if (planData.plan_status !== undefined || planData.on_trial !== undefined) {
            this.onTrial = planData.plan_status === PlanStatus.Trial || planData.on_trial === true;
          }
          this.refreshCouponPrices();
        }
      });

    this.refreshCouponPrices();
  }

  /**
   * Belt-and-braces (issue #410): the /pricing and /plans routes already
   * carry PricingEligibilityGuardService, but this component is also
   * embedded directly (bypassing routing/guards entirely) as
   * `<app-plans-details [onboarding]="true">` in the initial-signup wizard
   * (onboarding/step9). A brand-new signup can't yet be a company end user
   * at that point in the flow, so the block only applies outside onboarding.
   */
  get isCompanyEndUser(): boolean {
    return !this.onboarding && this.authService.isCompanyEndUser;
  }

  showTrial(plan: any): boolean {
    return (
      this.onboarding &&
      plan.key == "sales-pro" &&
      this.localPlanId == "freemium" &&
      !this.usedTrial &&
      // issue #605 AC-4: a contact-sales-only plan (at the currently
      // toggled interval — isContactSalesOnly(plan) reads `this.checked`)
      // never advertises a trial it cannot actually start. isCouponEligible()
      // already composes `!showTrial(plan) && !isContactSalesOnly(plan)`, so
      // adding the same guard here keeps its result unchanged for every plan.
      !this.isContactSalesOnly(plan)
    );
  }

  plan_details(plan: string) {
    if (!this.checked) {
      switch (plan) {
        case "starter":
          plan = this.checked ? "Starter" : "YearlyStarter";
          break;
        case "growth":
          plan = this.checked ? "Growth" : "YearlyGrowth";
          break;
        case "sales-pro":
          plan = this.checked ? "SalesPro" : "YearlySalesPro";
      }
    }
    this._router.navigate(["new-plan/" + plan]);
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  /**
   * `GET v1/subscriptions/plans` for both `/pricing` and its `/plans` alias
   * (issue #600 AC-1/AC-2/AC-4/AC-5/AC-6):
   * - `ignoreErrors: true` so `DataService.handleError` never toasts
   *   "Technical Error!" or navigates to `/session/error` for this request —
   *   the in-page error state below replaces both.
   * - `isLoader: false` (unchanged from before this fix) so this request
   *   never raises the app-wide `ngx-ui-loader` overlay in the first place.
   * - `timeout(PLANS_LOAD_TIMEOUT_MS)` turns a request that never answers
   *   into the same error state a 5xx produces, instead of leaving the
   *   loading placeholder up forever.
   * - `takeUntil(this._destroy$)` means a component destroyed while the
   *   request (or its timeout) is still pending never calls back into a
   *   torn-down component.
   * - `isValidPlansResponse()` (QA #602 F-2) catches a 200 whose body is
   *   valid JSON of the wrong shape (e.g. `{"result":null}`) before
   *   `response.result.forEach` can throw synchronously inside `next` — an
   *   error RxJS does not route to this same subscription's `error` handler,
   *   which used to strand `plansLoadState` on `"loading"` forever.
   *
   * @param isRetry set by `retryPlansLoad()` (QA #602 F-3): when true, once
   *   the load settles, focus moves to the reloaded content or back to
   *   "Try again", never left on `<body>`.
   */
  loadPlans(isRetry = false): void {
    this.plansLoadState = "loading";
    this.dataService
      .get({ url: "v1/subscriptions/plans", isLoader: false, ignoreErrors: true })
      .pipe(timeout(PLANS_LOAD_TIMEOUT_MS), takeUntil(this._destroy$))
      .subscribe({
        next: (response: any) => {
          if (!isValidPlansResponse(response)) {
            this.plansLoadState = "error";
            this.reportPlansLoadFailure(new InvalidPlansShapeError());
            if (isRetry) {
              this.focusPlansLoadResultAsync();
            }
            return;
          }
          response.result.forEach(({ identifier, unit_amount }) => {
            this.pricing[identifier] = unit_amount / 100;
          });
          this.plansLoadState = "ready";
          // A pending ?coupon= survives a load that failed then succeeded on
          // retry (AC-3): refreshCouponPrices() re-derives couponResults from
          // the just-loaded pricing/filteredPlans(), it is never cleared by
          // loadPlans()/retryPlansLoad() themselves.
          this.refreshCouponPrices();
          if (isRetry) {
            this.focusPlansLoadResultAsync();
          }
        },
        error: (error) => {
          this.plansLoadState = "error";
          this.reportPlansLoadFailure(error);
          if (isRetry) {
            this.focusPlansLoadResultAsync();
          }
        },
      });
  }

  /** Bound to the in-page error state's "Try again" button (issue #600 AC-2). */
  retryPlansLoad(): void {
    this.loadPlans(true);
  }

  /**
   * `focusPlansLoadResult()` needs the DOM Angular renders from the
   * `plansLoadState` assignment above; queuing it in a macrotask (rather than
   * calling it synchronously) lets that change detection pass run first
   * (QA #602 F-3).
   */
  private focusPlansLoadResultAsync(): void {
    setTimeout(() => focusPlansLoadResult(this.el.nativeElement), 0);
  }

  /** Reporting contract pinned by issue #600 AC-5: analytics + console, once per failed attempt. */
  private reportPlansLoadFailure(error: unknown): void {
    const status = classifyPlansLoadError(error);
    const route = "/pricing";
    // eslint-disable-next-line no-console
    console.error("[plans] load failed", { status, route });
    this.analyticsService.track("pricing_plans_load_failed", { status, route });
  }

  private stripeHandler() {
    this.dataService
      .get({ url: "v1/user", isLoader: false })
      .pipe(first())
      .subscribe((response: any) => {
        if (response && response.result) {
          this.stripeId = response.result.stripe_id ? response.result.stripe_id : "";
        }
      });

    // Stop generating intent for payment that won't be made here

    // this.stripeService
    //   .genPaymentIntent()
    //   .pipe(first())
    //   .subscribe((response: string) => {
    //     this.client_secret = response;
    //   });
  }

  public async confirmPaymentSetup() {
    if (this.client_secret !== "") {
      const { setupIntent, error } = await this.stripeService.stripe.confirmCardSetup(this.client_secret, {
        payment_method: {
          card: this.paymentElement,
          billing_details: { name: this.PaymentName.value },
        },
      });
      if (error) {
      } else {
        // The card has been verified successfully...
        this.stripeService
          .setDefaultPaymentMethod(setupIntent.payment_method)
          .pipe(
            takeUntil(this._destroy$),
            concatMap((response) => {
              if (response) {
                return this.stripeService.getDefaultPaymentMethod();
              }
            })
          )
          .subscribe((paymentId) => {
            this.stripeService
              .subToPlan(paymentId, this.planType)
              .pipe(takeUntil(this._destroy$))
              .subscribe((response) => {});
          });
      }
    }
  }
  setValue(e: any) {
    if (typeof e === "boolean") {
      this.checked = e;
    } else {
      this.checked = e.target.checked;
    }

    this.loadCtaScripts();
    // The billing interval just flipped, which changes every card's
    // plan_identifier ("sales-pro-monthly" <-> "sales-pro-yearly", etc.) —
    // request coupon validity for the newly-selected interval too (issue
    // #596 product decision 2). refreshCouponPrices()/fetchCouponPrice()
    // dedupe by (code, identifier), so toggling back never re-issues a
    // request already answered.
    this.refreshCouponPrices();
  }

  goToSalesPro() {
    hardNavigation.navigate(this.checked ? CTA_SALES_PRO_MONTHLY_URL : CTA_SALES_PRO_YEARLY_URL);
  }

  loadCtaScripts() {
    const scriptElement = this.scriptService.loadJsScript(this.renderer, "https://js.hscta.net/cta/current.js");

    scriptElement.onload = () => {
      const config = { useNewLoader: "true", region: "na1" };

      if (this.checked) {
        hbspt.cta.load(11964, CTA_SALES_PRO_MONTHLY_ID, config);
      } else {
        hbspt.cta.load(11964, CTA_SALES_PRO_YEARLY_ID, config);
      }
    };

    scriptElement.onerror = () => {};
  }

  // Issue #607: delegates its final rounding to the shared formatter
  // instead of its own `toFixed(2)` (this call site was already correct —
  // this only removes the fourth private copy of the rounding logic).
  displayedPrice(plan: any, anual = false): string {
    const amount = this.pricing[this.planIdentifier(plan, this.checked)];

    return formatPrice(!this.checked ? amount / (anual ? 1 : 12) : amount);
  }

  /**
   * The coupon-discounted "$/mo" figure for `plan` at the current billing
   * interval, or `undefined` when no valid, priced discount is held for it
   * (issue #596 AC-3/AC-6/AC-7, product decision 2). `undefined` covers
   * every "show the full price instead" case in one place: no pending code,
   * a code invalid/refused for this specific plan+interval, the validation
   * request still in flight or failed, pricing not loaded yet (never NaN —
   * same class as issue #594's "Pay $NaN" fix), and — deliberately — the
   * disabled "Your Current Plan" card and the onboarding "Start My Free
   * Trial" card, neither of which may ever show a coupon price.
   *
   * Reads `pricing`/`couponResults` fresh on every call (Angular re-invokes
   * template method bindings on change detection) rather than caching a
   * computed dollar figure, so a coupon result that arrives before pricing
   * has loaded is still picked up correctly once pricing does.
   */
  public discountedPrice(plan: any): string | undefined {
    const discountedCharge = this.discountedCharge(plan);
    if (discountedCharge === undefined) {
      return undefined;
    }

    const perMonth = this.checked ? discountedCharge : discountedCharge / 12;
    return formatPrice(perMonth);
  }

  /**
   * The coupon-discounted annual total for `plan` — the same figure Stripe
   * actually charges on the payment page for a yearly plan/coupon
   * combination (issue #597 F-1: every price-bearing line on a card, not
   * only the $/mo figure, must come from this same shared helper). `pricing`
   * for a yearly `identifier` is already the full annual charge, so this is
   * `discountedCharge(plan)` verbatim — `discountedPrice()` is the one that
   * additionally divides it by 12 for the $/mo figure. `undefined` for
   * every case `discountedCharge()` returns `undefined` for (no eligible,
   * priced, valid discount held for this plan/interval).
   */
  public discountedAnnualTotal(plan: any): string | undefined {
    const discountedCharge = this.discountedCharge(plan);
    return discountedCharge === undefined ? undefined : formatPrice(discountedCharge);
  }

  /**
   * The coupon-discounted charge for `plan`'s current identifier, in the
   * same units `pricing[identifier]` uses (the full annual total for a
   * yearly identifier, the monthly amount for a monthly one) — the single
   * computation `discountedPrice()` and `discountedAnnualTotal()` both
   * derive their displayed figure from, so a yearly card's $/mo line and its
   * "Billed annually at $…" line can never disagree (issue #597 F-1).
   */
  private discountedCharge(plan: any): number | undefined {
    if (!this.isCouponEligible(plan)) {
      return undefined;
    }

    const identifier = this.planIdentifier(plan, this.checked);
    const coupon = this.couponResults[identifier];
    const chargeAmount = this.pricing[identifier];
    if (!coupon || !chargeAmount) {
      return undefined;
    }

    return Number(applyDiscount(chargeAmount, couponDiscountAmount(coupon, chargeAmount)));
  }

  /**
   * Requests `POST v1/subscriptions/coupon` for every currently visible
   * card's plan_identifier at the current billing interval, when a coupon
   * code is pending (issue #596 product decision 2 — every plan the pending
   * code is valid for shows the coupon price, not only the trialing user's
   * own plan). No-op with no pending code (clears any previously held
   * results, so a code cleared mid-visit stops showing stale prices).
   * Called after the code is captured (ngOnInit), whenever the store's plan
   * data changes filteredPlans()'s visible tiers (ngOnInit's
   * selectPlanData subscription), and on every billing-interval toggle
   * (setValue()).
   */
  private refreshCouponPrices(): void {
    const code = this.pendingCoupon.peek();
    if (!code) {
      this.pendingCouponCode = null;
      this.couponResults = {};
      this.couponRequestsIssued.clear();
      return;
    }

    if (code !== this.pendingCouponCode) {
      // A different code than the one already validated (e.g. a fresh
      // ?coupon= replaced an older stash) invalidates every previous result.
      this.couponResults = {};
      this.couponRequestsIssued.clear();
    }
    this.pendingCouponCode = code;

    this.filteredPlans()
      .filter((plan) => this.isCouponEligible(plan))
      .forEach((plan) => {
        this.fetchCouponPrice(code, this.planIdentifier(plan, this.checked));
      });
  }

  /**
   * Whether `plan`'s card, at the current billing interval, is allowed to
   * show a coupon price at all — the disabled "Your Current Plan" card and
   * the onboarding "Start My Free Trial" card never do (issue #596 AC-6),
   * and neither does a card whose plan is absent from `v1/subscriptions/plans`
   * (issue #603 AC-5: never a discounted price, never a coupon request, for
   * an identifier the backend never priced). Shared by `discountedPrice()`
   * (what to render) and `refreshCouponPrices()` (what to request), so the
   * two can never disagree about which cards are eligible.
   */
  private isCouponEligible(plan: any): boolean {
    return !this.currentPlan(plan) && !this.showTrial(plan) && !this.isContactSalesOnly(plan);
  }

  /**
   * One `POST v1/subscriptions/coupon` request per (code, identifier) —
   * deduped via `couponRequestsIssued` — with `ignoreErrors = true` (as the
   * payment page's auto-apply path already does) so a coupon-service 5xx
   * never ejects a /pricing visitor to the global error page (issue #596
   * AC-3 negative path): it just leaves that card at full price.
   */
  private fetchCouponPrice(code: string, identifier: string): void {
    const requestKey = `${code}:${identifier}`;
    if (this.couponRequestsIssued.has(requestKey)) {
      return;
    }
    this.couponRequestsIssued.add(requestKey);

    this.stripeService
      // isLoader: false (issue #600 AC-6): a coupon-price validation background
      // request must never raise the app-wide ngx-ui-loader overlay — the same
      // rule ignoreErrors already followed for its error handling.
      .retrieveCouponObject(code, identifier, true, false)
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: (response: any) => {
          const coupon = response?.result;
          if (coupon?.valid === true) {
            this.couponResults[identifier] = coupon;
          } else {
            delete this.couponResults[identifier];
          }
        },
        error: () => {
          delete this.couponResults[identifier];
        },
      });
  }

  disableButtons(disabled: boolean): void {
    this.buttons.forEach((button) => {
      button.nativeElement.disabled = disabled;
      if (disabled === true) {
        this.renderer.setStyle(button.nativeElement, "pointer-events", "none");
        this.renderer.setStyle(button.nativeElement, "opacity", "0.65");
      } else {
        this.renderer.removeStyle(button.nativeElement, "pointer-events");
        this.renderer.removeStyle(button.nativeElement, "opacity");
      }
    });
  }

  selectPlan(plan, yearly) {
    this.disableButtons(true);

    let mp;
    switch (plan.key) {
      case "free":
      case "freemium":
        mp = "";
        break;
      case "starter":
        mp = yearly ? "YearlyStarter" : "Starter";
        break;
      case "growth":
        mp = yearly ? "YearlyGrowth" : "Growth";
        break;
      case "sales-pro":
        mp = yearly ? "YearlySalesPro" : "SalesPro";
        break;
    }
    this.plan_details(mp);
    this.disableButtons(false);
  }

  /**
   * Sibling site of the refreshLocalPlanState() guard (issue #592 F-2):
   * called directly by the template every change detection, so it must
   * never throw on the same "plan not loaded yet" state — most reliably
   * reproduced right after a sign-in/sign-up replay lands on
   * `/pricing?coupon=` while `v2/plans/current` is still in flight (issue
   * #592/#593 F-7, left by the F-2 fix). Returns undefined instead of
   * throwing `undefined.toLowerCase()`; the template hides the "You are
   * currently on the …" line until this resolves to a real plan name
   * instead of rendering it blank.
   */
  actualPlanDescription(): string | undefined {
    const planKeySource = this.localPlanIdType ?? this.localPlanId;
    if (typeof planKeySource !== "string") {
      return undefined;
    }
    switch (planKeySource.toLowerCase()) {
      case "free":
      case "freemium":
        return "Freemium Plan";
      case "starter":
        return "Starter";
      case "starter-yearly":
        return "Starter - YR Plan";
      case "growth":
        return "Growth";
      case "growth-yearly":
        return "Growth - YR Plan";
      case "sales-pro":
      case "sales-pro-monthly":
        return "Business Pro";
      case "sales-pro-yearly":
        return "Business Pro - YR Plan";
    }
  }

  filteredPlans() {
    if (this.onboarding || this.onTrial) return this.plans;
    // The billing toggle (yearly/monthly) never changes which tiers are visible —
    // the user's current tier stays visible regardless of `checked` or of whether
    // the stored plan identifier happens to be the yearly SKU.
    return this.plans.filter((plan, index) => index >= this.planIndex);
  }

  public plans = [
    {
      key: "starter",
      name: "Starter",
      description: "Everything in Freemium, <br>Plus...",
      current: false,
      popular: false,
      button: "Choose Starter",
      freeAIPrompts: "10",
      dots: [
        `<b>FlyMSG</b> <img src="../../../assets/images/ai.svg" width="13px"> : AI Writing for Email and Social Media`,
        "<b>20</b> Grammar/Spelling Daily Actions",
        "Up to <b>50</b> Templates FlyPlates",
        "Up to 300 Shortcodes FlyMSGs",
        // '<b>25,000 Characters per FlyMSG</b>',
        "Up to <b>14</b> Categories & <b>28</b> Subcategories",
        // 'Spell Check for <b>All<b> Languages',
        "<b>All</b> Fonts in <b>All</b> Font Sizes",
      ],
      keys: [
        "Access to Technical Support",
        "Insert Images into FlyMSGs and FlyPlates",
        "All Text Styling: Italicize, Underline, Bullets, & More",
        "Advanced Search",
      ],
    },
    {
      key: "growth",
      name: "Growth",
      description: "Everything In Starter, <br>Plus...",
      current: false,
      popular: true,
      button: "Choose Growth",
      freeAIPrompts: "30",
      dots: [
        `<b>FlyMSG</b> <img src="../../../assets/images/ai.svg" width="13px"> : AI Writing for Email and Social Media`,
        "<b>Unlimited</b> Grammar/Spelling Actions",
        "<b>Unlimited</b> <s>Templates</s> FlyPlates",
        "<b>Unlimited</b> <s>Shortcodes</s> FlyMSGs",
        "<b>Unlimited</b> Characters Per FlyCut",
        "<b>Unlimited</b> Categories & Subcategories",
        // "Spell Checks for <b>All</b> Languages",
        "<b>All</b> Font Sizes & Styles",
      ],
      keys: [
        "Enhanced Text & Paragraph Styling",
        "Insert All Media into FlyMSGs and FlyPlates",
        "Greater File Storage and Retention",
        "Supports All Languages",
      ],
    },
    {
      key: "sales-pro",
      name: "Business Pro",
      description: "Everything in Growth, <br>Plus...",
      current: false,
      popular: false,
      button: "Choose Business Pro",
      freeAIPrompts: "70",
      dots: [
        `<b>FlyMSG</b> <img src="../../../assets/images/ai.svg" width="13px"> : AI Writing for Email and Social Media`,
        "<b>Unlimited</b> On-demand Access",
        "<b>15+</b> Hours of Sales Prospecting Education",
        "<b>50+</b> Prospecting Scripts",
        "<b>13</b> Messaging Playbooks",
        "Quarterly Sales Content Updates",
      ],
      keys: [
        "All On-demand Content",
        "Learn and Practice Your Way",
        "Tons of Freebies",
        '<a href="https://vengreso.com/modern-sales-mastery-individuals" target="_blank">Read About Business Pro Here</a>',
      ],
    },
  ];
}
